import React from 'react';
import {
  AlertTriangle, ArrowDownLeft, ArrowLeftRight, ArrowUpRight, CheckCircle2, ClipboardList, HelpCircle,
  MapPin, Send, ShieldAlert, ShieldCheck, Truck, Undo2, UserCheck,
} from 'lucide-react';
import { DANGEROUS_REASONS, DIRECTION_LABELS, TRUST_LEVELS, reasonLabel, statusMeta } from '../../constants/shipments';

// An icon next to the text keeps the status readable without colour.
const STATUS_ICONS = {
  objednano: ClipboardList, odeslano: Send, v_preprave: Truck, k_vyzvednuti: MapPin,
  doruceno: CheckCircle2, problem: AlertTriangle, vraceno: Undo2, review: HelpCircle,
};

export const StatusIcon = ({ status, size = 12 }) => {
  const Icon = STATUS_ICONS[statusMeta(status).value] || HelpCircle;
  return <Icon size={size} aria-hidden="true" />;
};

export const StatusBadge = ({ status, size = 12 }) => {
  const meta = statusMeta(status);
  return (
    <span className="shp-badge" style={{ background: meta.bg, color: meta.color }}>
      <StatusIcon status={status} size={size} /> {meta.label}
    </span>
  );
};

const DIRECTION_ICONS = { prichozi: ArrowDownLeft, odchozi: ArrowUpRight, neurceno: ArrowLeftRight };

export const DirectionLabel = ({ direction, iconOnly = false }) => {
  const Icon = DIRECTION_ICONS[direction] || ArrowLeftRight;
  const text = DIRECTION_LABELS[direction] || 'Neurčeno';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }} title={iconOnly ? text : undefined}>
      <Icon size={15} aria-hidden="true" />
      <span className={iconOnly ? 'shp-sr' : undefined}>{text}</span>
    </span>
  );
};

export const ReasonChips = ({ reasons }) => {
  if (!Array.isArray(reasons) || reasons.length === 0) return null;
  return (
    <>
      {reasons.map((key) => {
        const danger = DANGEROUS_REASONS.includes(key);
        return (
          <span key={key} className={`shp-tag ${danger ? 'shp-tag--bad' : 'shp-tag--warn'}`}>
            <AlertTriangle size={12} aria-hidden="true" /> {reasonLabel(key)}
          </span>
        );
      })}
    </>
  );
};

export const TrustBadge = ({ trust }) => {
  const trusted = trust === 'trusted_carrier' || trust === 'known_party';
  const Icon = trust === 'known_party' ? UserCheck : trusted ? ShieldCheck : ShieldAlert;
  return (
    <span className={`shp-tag ${trusted ? 'shp-tag--ok' : 'shp-tag--bad'}`}>
      <Icon size={12} aria-hidden="true" /> {TRUST_LEVELS[trust] || 'Neověřený odesílatel'}
    </span>
  );
};
